import { availableLangs, Lang } from 'core/localize-types';
import { useQueryParams } from './use-get-query-params';

export default function useLang(): Lang {
  const lang = useQueryParams('l') as Lang;
  return availableLangs.some((x) => x === lang) ? lang : Lang.EN;
}
